import { KeyValue } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  ElementRef,
  Input,
  TemplateRef
} from '@angular/core';
import { WidgetPanel } from 'src/app/interfaces/widget-panel';

@Component({
  selector: 'app-title-content-widget',
  templateUrl: './title-content-widget.component.html',
  styleUrls: ['./title-content-widget.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TitleContentWidgetComponent {
  constructor(private elementRef: ElementRef) {}

  // This is used for conditional multi-slot projection. We can project template refs with the template variable
  // #titleContentPanel within the ng-container element defined in this component's template.
  @ContentChildren('titleContentPanel')
  innerPanelTemplateRefs: TemplateRef<any>[] = [];

  @Input() widgetPanel: WidgetPanel = { style: {} };

  @Input() title = '';

  keyValuePairDefaultOrder(
    a: KeyValue<any, any>,
    b: KeyValue<any, any>
  ): number {
    return 0;
  }

  onScroll(event: Event) {
    const panelScrollEvent = new CustomEvent('panelScroll', {
      bubbles: true,
      detail: { event }
    });

    this.elementRef.nativeElement.dispatchEvent(panelScrollEvent);
  }

  ngOnInit(): void {}
}
